import { get } from 'lodash';
import { convertObjToCamelCase, retrieveDataMapper } from '../..';

export const transformGetAllGuardianV2 = ({
  resp = [],
  childRelations = {},
  centreVerifications = {},
  children = [],
  currentLevels,
  centres = {},
  levels = [],
  childLevels = [],
  enrolmentStatus = {},
  codes = [],
  centreID,
}) => {
  return {
    data: {
      getAllGuardianV2: {
        data: (get(resp, 'data.data') || []).map(guardian => ({
          ...convertObjToCamelCase(guardian),
          guardianChildRelations: {
            data: (get(childRelations, `${guardian?.id}.data`) || []).map(
              cr => ({
                ...convertObjToCamelCase(cr),
                child: {
                  ...retrieveDataMapper(children, cr?.fk_child, [
                    'ID:id',
                    'firstname',
                    'lastname',
                    'image_key',
                    'image_key_presigned_url',
                    'birth_certificate',
                  ]),
                  currentLevel: (() => {
                    const currentLv = retrieveDataMapper(
                      currentLevels,
                      cr?.fk_child,
                      ['fk_centre', 'ID:id']
                    );
                    if (!currentLv) return null;
                    return {
                      centre: retrieveDataMapper(
                        centres?.data,
                        currentLv?.fkCentre,
                        ['ID:id', 'label']
                      ),
                      level: retrieveDataMapper(levels, currentLv?.ID, [
                        'ID:id',
                        'label',
                      ]),
                    };
                  })(),
                  childLevels: {
                    data: childLevels
                      ?.filter(f => f.fk_child === cr?.fk_child)
                      ?.map(d => ({
                        fkCentre: d?.fk_centre,
                        centre: retrieveDataMapper(
                          centres?.data,
                          d?.fk_centre,
                          ['ID:id', 'label']
                        ),
                      })),
                  },
                  enrolmentStatus: retrieveDataMapper(
                    enrolmentStatus,
                    cr?.fk_child,
                    ['status', 'label']
                  ),
                },
                code: retrieveDataMapper(codes, cr?.fk_relation, [
                  'label',
                  'description',
                ]),
              })
            ),
          },
          guardianCentreVerifications: {
            data: (
              get(
                centreVerifications,
                `${guardian?.id}.guardian_centre_verification.data`
              ) || []
            ).map(cv => ({
              ...convertObjToCamelCase(cv, [], ['status:status_string']),
              centre: retrieveDataMapper(centres?.data, cv?.fk_centre, [
                'label',
              ]),
            })),
            totalCount: get(
              centreVerifications,
              `${guardian?.id}.guardian_centre_verification.totalCount`,
              0
            ),
          },
          verification: centreID
            ? retrieveDataMapper(
                get(
                  centreVerifications,
                  `${guardian?.id}.guardian_centre_verification.data`
                ),
                centreID,
                [
                  'ID:id',
                  'status:status_string',
                  'updated_by',
                  'remark',
                  'fk_reason',
                ],
                'fk_centre'
              )
            : null,
        })),
        totalCount: resp?.data?.total_count || 0,
      },
    },
    success: true,
  };
};

export default { transformGetAllGuardianV2 };
